import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {MissedPaymentForm} from "./MissedPaymentForm";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {Navigate} from "react-router-dom";
import {getSessionStorage, setSessionStorage} from "../../../../../CommonFunctions";
import {
    AnnualPolicyPremiumTypeEnum,
    FalconNavigatorHeader,
    ICustomerPortalService,
    ProductsEnum,
    Types
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import FalconFooter from "../../../../../components/navigation/FalconFooter";

interface IParams {
    policyNumber: string
    invoiceId: string
    [key: string]: string | undefined
}

interface IState {
    premiumType?: string,
    dataLoaded: boolean
}

@authorize
export class MissedPaymentPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();
    private readonly paymentPaid: any;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.paymentPaid = window.sessionStorage.getItem("paymentAmount");

        this.state = {
            dataLoaded: false
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Payment");

        const product = this.props.location?.state?.product ?
            this.props.location?.state?.product : getSessionStorage("missedPaymentProduct")
        if (product) {
            setSessionStorage("missedPaymentProduct", product);
        } else {
            this.customerPortalService.getPolicies().subscribe(policies => {
                const currentPolicy = policies.filter(policy => policy.policyNumber === this.props.params.policyNumber)[0];
                setSessionStorage("missedPaymentProduct", currentPolicy.interaction.product);
            });
        }
        this.customerPortalService.getPolicyPremiumTypeByPolicyNumber(this.props.params.policyNumber).subscribe((result: string) => {
            this.setState({
                premiumType: result,
                dataLoaded: true
            })
        });
    }

    public render() {
        const dataLoaded = this.state.dataLoaded;
        return (
            <React.Fragment>
                <Overlay show={!dataLoaded}/>
                <FalconHeader/>
                {dataLoaded && this.renderPageContents()}
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private getRedirectUrl = (): string => {
        const product: string = this.props.location?.state?.product ?
            this.props.location?.state?.product : getSessionStorage("missedPaymentProduct");
        let redirectUrl: string;

        if (product === ProductsEnum.WOLF_MOTOR || product === ProductsEnum.HOME) {
            redirectUrl = this.state.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY
                ? `/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`
                : `/dashboard/annualPaymentHistory/${this.props.params.policyNumber}`;
        } else {
            redirectUrl = "/dashboard/paymentHistory";
        }

        return redirectUrl;
    }

    private renderPageContents(): React.ReactNode {
        if (this.paymentPaid) {
            return <Navigate to={this.getRedirectUrl()}/>
        } else {
            return (
                <div className="plugin">
                    <FalconNavigatorHeader back={this.getRedirectUrl()} title="Payment"/>
                    <MissedPaymentForm
                        verifyNewCardFailed={this.props.location?.state?.verifyCardFailed}
                        product={this.props.location?.state?.product ?
                            this.props.location?.state?.product : getSessionStorage("missedPaymentProduct")}
                        policyNumber={this.props.params.policyNumber}
                        invoiceId={this.props.params?.invoiceId}/>
                    {this.pluginTemplates.renderBackReloadLink("Back", false, this.getRedirectUrl())}
                </div>
            );
        }
    }
}

export const MissedPaymentPage = withRouter<{}, IParams>(MissedPaymentPagePlain)
